import React from 'react';

import ArrowIcon from '../../assets/arrow-right.svg';
import './styles.scss';

const Arrow = ({ directionDown }) => {
  const classNames = `img-for-icon${directionDown ? ' down' : ''}`;
  return <img className={classNames} src={ArrowIcon} style={{ width: '20px' }} alt=">" />;
};
export default Arrow;
